import React from "react"

interface AuthSidebarProps {
  isSignUp: boolean
  switchTo: (v: boolean) => void
}

const AuthSidebar: React.FC<AuthSidebarProps> = ({ isSignUp, switchTo }) => {
  return (
    <div className="hidden md:flex flex-col justify-between w-[360px] flex-shrink-0 bg-[#0F52BA] p-10 relative overflow-hidden">

       <div className="absolute -top-20 -left-20 w-64 h-64 rounded-full bg-white/5" />
      <div className="absolute -bottom-16 -right-16 w-72 h-72 rounded-full bg-white/5" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-full bg-white/[0.03]" />

       <div className="relative z-10">
        <img
          src="/metal2000.svg"
          alt="Metal 2000"
          className="h-9 w-auto brightness-0 invert opacity-90"
        />
      </div>

       <div className="relative z-10 flex flex-col gap-4">
        {isSignUp ? (
          <>
            <h2 className="text-2xl font-bold text-white leading-tight">
              Bienvenue dans l'équipe !
            </h2>
            <p className="text-sm text-blue-100/80">
              Créez votre compte pour gérer vos fiches Google Business.
            </p>
          </>
        ) : (
          <>
            <h2 className="text-2xl font-bold text-white leading-tight">
              Bonne journée !
            </h2>
            <p className="text-sm text-blue-100/80">
              Connectez-vous pour accéder à votre espace.
            </p>
          </>
        )}

        <div className="flex flex-col gap-2 mt-2">
          {["Gestion des fiches GBP", "Suivi des performances", "Gestion des avis"].map((f) => (
            <div key={f} className="flex items-center gap-2 text-xs text-blue-100/70">
              <div className="w-1.5 h-1.5 rounded-full bg-blue-300/60" />
              {f}
            </div>
          ))}
        </div>
      </div>

       <div className="relative z-10">
        {isSignUp ? (
          <p className="text-xs text-blue-100/60">
            Déjà un compte ?{" "}
            <button onClick={() => switchTo(false)} className="text-white font-bold hover:underline">
              Se connecter
            </button>
          </p>
        ) : (
          <p className="text-xs text-blue-100/60">
             
          </p>
        )}
      </div>
    </div>
  )
}

export default AuthSidebar